import * as actionTypes from "../actionTypes";
import {EVENT_MODAL_DATA} from "../actionTypes";

export const eventModalAction = (data) => {
  return {
    type: actionTypes.EVENT_MODAL_VISIBLE,
    value: data
  }
};
export const eventModalDataAction = (data) => {
  return {
    type: actionTypes.EVENT_MODAL_DATA,
    value: data
  }
}
